// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"return-info-content_wrapper__E1toC","infoWrapper":"return-info-content_infoWrapper__3ViCE"};